export default __webpack_public_path__ + "bcb7f97b61f9ca7d61594693dfe84f8c.png";